const tapsHeader = (): JSX.Element => {
  return (
    <div className="taps-header">
      <div className="taps-header-content">
        <h1>TAPS</h1>
        <h2>Tobacco, Alcohol, Prescription medication, and other Substance use Tool</h2>
      </div>
    </div>
  );
};
export default tapsHeader;
